import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { parsePhoneNumber } from 'libphonenumber-js/mobile';

@Directive({
  selector: '[formValidatorsPhonNumberValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PhonNumberValidatorDirective, multi: true }],
  standalone: true,
})
export class PhonNumberValidatorDirective implements Validator {
  public validate(control: AbstractControl): ValidationErrors {
    return PhonNumberValidators.phoneNumberValidator()(control);
  }
}

export class PhonNumberValidators {
  public static phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validationError = {
        phoneInput: 'invalid',
      };
      if (control.value) {
        try {
          const phoneNumber = parsePhoneNumber(control.value);
          const isValid = phoneNumber.isValid();
          const nrType = phoneNumber.getType();
          const isMobileNr = nrType === 'MOBILE' || nrType === 'FIXED_LINE_OR_MOBILE';

          if (!isValid) {
            return validationError;
          } else if (!isMobileNr) {
            validationError.phoneInput = 'notmobile';
            return validationError;
          } else {
            return null;
          }
        } catch (e) {
          return validationError;
        }
      } else {
        return null;
      }
    };
  }
}
